import { useMemo } from "react";
import { useOptionalLayoutActions } from "@/contexts/layout/LayoutActionsProvider";
import { useReferenceNavigation } from "@/contexts/session/ui/use-reference-navigation";
import { useSeqLog } from "@/hooks/telemetry";
import { buildCreferenceInternalActions } from "./creferenceInternalActionBuilders";
import {
  REF_CLICK_DEBUG_FLOW,
  SEQ_LOG_COMPONENT_NAME,
} from "./creferenceInteractionConstants";
import type {
  InternalReferenceActionMap,
  UseCreferenceInteractionInput,
} from "./creferenceInteractionTypes";

interface UseCreferenceInternalActionsInput
  extends Pick<
    UseCreferenceInteractionInput,
    | "collab"
    | "file"
    | "isCurrentUserReference"
    | "member"
    | "normalizedEntityId"
    | "product"
    | "version"
  > {
  showMemberGlimpse: () => void;
}

export function useCreferenceInternalActions({
  collab,
  file,
  isCurrentUserReference,
  member,
  normalizedEntityId,
  product,
  showMemberGlimpse,
  version,
}: UseCreferenceInternalActionsInput): InternalReferenceActionMap {
  const referenceNavigation = useReferenceNavigation();
  const layoutActions = useOptionalLayoutActions();
  const seqLog = useSeqLog(SEQ_LOG_COMPONENT_NAME, {
    flow: REF_CLICK_DEBUG_FLOW,
  });

  return useMemo(
    () => buildCreferenceInternalActions({
      collab,
      file,
      isCurrentUserReference,
      layoutActions,
      member,
      normalizedEntityId,
      product,
      referenceNavigation,
      seqLog,
      showMemberGlimpse,
      version,
    }),
    [
      collab,
      file,
      isCurrentUserReference,
      layoutActions,
      member,
      normalizedEntityId,
      product,
      referenceNavigation,
      seqLog,
      showMemberGlimpse,
      version,
    ],
  );
}
